import React from "react";
import {Button, Pane, PlusIcon, SelectField} from "evergreen-ui";
import {datasourceTypeObject, evaporationConstructor} from "../../common/constructorObject";
import {findFirstByCode, findFirstByName} from "../../common/matchMethods";
import {getCodesByStationAndDatasourceType, getDatasourceTypesByStation} from "../../decadeConstructor/ApiCalls";
import {useDispatch} from "react-redux";

export default function EvaporationFilterPanel({
                                                 isFullInfo,
                                                 constructor,
                                                 possibleDatasourceTypes,
                                                 onAddFilter,
                                                 onDeleteFilter,
                                                 onSelectDatasourceTypeForLevel,
                                                 onSelectDatasourceTypeForRainfall,
                                                 onSelectCodeForWaterTemp,
                                                 onSelectCodeForWindSpeed,
                                                 stations
                                               }) {
  if (isFullInfo === undefined || isFullInfo) {
    getDatasourceTypesByStation(constructor.station.id).then((res) => {
      possibleDatasourceTypes = res.data
    })
  } else {
    if ((constructor.waterTemperatureFilterObject.type.name === undefined
            && constructor.windSpeedFilterObject.type.name === undefined)
        || stations.length === 0
    ) {
      possibleDatasourceTypes = []
    } else {
      let res = findFirstByName(stations, constructor.station.name)

      if (res.id === undefined) {
        possibleDatasourceTypes = []
      } else {
        possibleDatasourceTypes = constructor.station.sourcesTypes
      }
    }
  }

  const dispatch = useDispatch();
  const isStationSet = constructor.station.id !== -1
  const innerTypesForDatasource = possibleDatasourceTypes !== null && possibleDatasourceTypes.length !== 0
      ? possibleDatasourceTypes
      : [];
  const [possibleCodesForWaterTemp, setPossibleCodesForWaterTemp] = React.useState(
      constructor.waterTemperatureFilterObject.type === null ? [] :
      constructor.waterTemperatureFilterObject.type.codes
  );
  const [possibleCodesForWindSpeed, setPossibleCodesForWindSpeed] = React.useState(
      constructor.windSpeedFilterObject.type === null ? [] :
      constructor.windSpeedFilterObject.type.codes
  )

  const [waterCodesLoading, setWaterCodesLoading] = React.useState(possibleCodesForWaterTemp == undefined)
  const [windCodesLoading, setWindCodesLoading] = React.useState(possibleCodesForWindSpeed == undefined)

  if (waterCodesLoading) {
    let datasourceId = constructor.waterTemperatureFilterObject.type.id

    getCodesByStationAndDatasourceType(constructor.station.id, datasourceId).then((response) => {
      setPossibleCodesForWaterTemp(response.data)
      setWaterCodesLoading(false)
    })
  }

  if (windCodesLoading) {
    let datasourceId = constructor.windSpeedFilterObject.type.id

    getCodesByStationAndDatasourceType(constructor.station.id, datasourceId).then((response) => {
      setPossibleCodesForWindSpeed(response.data)
      setWindCodesLoading(false)
    })
  }

  const smthIsLoading = waterCodesLoading || windCodesLoading
  function handleDatasourceTypeForWaterTemperature(name) {
    if (name === -1) {
      let res = {...datasourceTypeObject}
      dispatch(onSelectDatasourceTypeForRainfall(res))
      return
    }

    let res = findFirstByName(innerTypesForDatasource, name)

    getCodesByStationAndDatasourceType(constructor.station.id, res.id).then((result) => {
      res = {id: res.id, name: res.name, codes: result.data}
      setPossibleCodesForWaterTemp(result.data)
      dispatch(onSelectDatasourceTypeForRainfall(res))
    })

  }

  function handleDatasourceTypeForWindSpeed(name) {
    if (name === -1) {
      let res = {...datasourceTypeObject}
      dispatch(onSelectDatasourceTypeForLevel(res))
      return;
    }

    let res = findFirstByName(innerTypesForDatasource, name)
    getCodesByStationAndDatasourceType(constructor.station.id, res.id).then((result) => {
      res = {id: res.id, name: res.name, codes: result.data}
      setPossibleCodesForWindSpeed(result.data)
      dispatch(onSelectDatasourceTypeForLevel(res))
    })
  }

  function onSelectWaterTempCode(selectedItem) {
    let res = findFirstByCode(possibleCodesForWaterTemp, selectedItem)
    dispatch(onSelectCodeForWaterTemp(res))
  }

  function onSelectWindSpeedCode(selectedItem) {
    let res = findFirstByCode(possibleCodesForWindSpeed, selectedItem)
    dispatch(onSelectCodeForWindSpeed(res))
  }

  if (smthIsLoading) {
    return (
        <></>
    );
  }

  function getNullableCode(meteocode) {
    if (meteocode === null || meteocode === undefined) {
      return -1
    }
    return meteocode.code
  }

  function getNullableType(type) {
    if (type === null || type === undefined) {
      return -1
    }
    return type.name
  }

  return (
      <Pane marginBottom={6} alignItems={"top"}>
        <Pane display="flex" columnGap={30}>
          <Pane marginTop={30}><h5>Температура воды: </h5></Pane>
          <Pane verticalAlign={"top"}>
            <SelectField
                label={"Тип источника"}
                width={290}
                onChange={e => handleDatasourceTypeForWaterTemperature(e.target.value)}
                value={getNullableType(constructor.waterTemperatureFilterObject.type)}
                marginTop={-4.5}
                disabled={constructor.station.id === -1 || isFullInfo}
            >
              <option value={-1}>Выберите тип источника</option>
              {innerTypesForDatasource.map((type) => <option key={type.name} value={type.name}>{type.name}</option>)}
            </SelectField>
          </Pane>

          <Pane verticalAlign={"top"}>
            <SelectField
                label={"Метеокод"}
                disabled={
                  constructor.waterTemperatureFilterObject.type === null
                    || constructor.waterTemperatureFilterObject.type.id === -1
                    || isFullInfo
                }
                width={220}
                onChange={e => onSelectWaterTempCode(e.target.value)}
                value={getNullableCode(constructor.waterTemperatureFilterObject.meteoCode)}
                marginTop={-4.5}
            >
              <option value={-1}>Выберите метеокод</option>
              {possibleCodesForWaterTemp.map((ent) => <option key={ent.code} value={ent.code}>{ent.code}</option>)}
            </SelectField>
          </Pane>
        </Pane>

        <Pane display="flex" columnGap={50}>
          <Pane marginTop={15}><h5>Скорость ветра: </h5></Pane>
          <Pane verticalAlign={"top"}>
            <SelectField
                label={"Тип источника"}
                value={getNullableType(constructor.windSpeedFilterObject.type)}
                onChange={e => handleDatasourceTypeForWindSpeed(e.target.value)}
                width={290}
                marginTop={-15}
                disabled={constructor.station.id === -1 || isFullInfo}
            >
              <option value={-1}>Выберите тип источника</option>
              {innerTypesForDatasource.map((type) => <option key={type.name} value={type.name}>{type.name}</option>)}
            </SelectField>
          </Pane>

          <Pane verticalAlign={"top"}>
            <SelectField
                label={"Метеокод"}
                disabled={
                  constructor.windSpeedFilterObject.type === null
                    || constructor.windSpeedFilterObject.type.id === -1
                    || isFullInfo
                }
                width={220}
                onChange={e => onSelectWindSpeedCode(e.target.value)}
                value={getNullableCode(constructor.windSpeedFilterObject.meteoCode)}
                marginTop={-15}
                marginLeft={-20}
            >
              <option value={-1}>Выберите метеокод</option>
              {possibleCodesForWindSpeed.map((ent) => <option key={ent.code} value={ent.code}>{ent.code}</option>)}
            </SelectField>
          </Pane>
        </Pane>

      </Pane>
  );
}